module.exports = __webpack_public_path__ + "static/img/HanYuan_Banner_winter.dffa641b.jpg";